"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDAOLogicV2__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "AdminOnly",
        type: "error",
    },
    {
        inputs: [],
        name: "CantCancelExecutedProposal",
        type: "error",
    },
    {
        inputs: [],
        name: "CantVetoExecutedProposal",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidMaxQuorumVotesBPS",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidMinQuorumVotesBPS",
        type: "error",
    },
    {
        inputs: [],
        name: "MinQuorumBPSGreaterThanMaxQuorumBPS",
        type: "error",
    },
    {
        inputs: [],
        name: "PendingVetoerOnly",
        type: "error",
    },
    {
        inputs: [],
        name: "UnsafeUint16Cast",
        type: "error",
    },
    {
        inputs: [],
        name: "VetoerBurned",
        type: "error",
    },
    {
        inputs: [],
        name: "VetoerOnly",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint16",
                name: "oldMaxQuorumVotesBPS",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "newMaxQuorumVotesBPS",
                type: "uint16",
            },
        ],
        name: "MaxQuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint16",
                name: "oldMinQuorumVotesBPS",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "newMinQuorumVotesBPS",
                type: "uint16",
            },
        ],
        name: "MinQuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingVetoer",
                type: "address",
            },
        ],
        name: "NewPendingVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "NewVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreatedWithRequirements",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ProposalQueued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProposalThresholdBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "ProposalThresholdBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalVetoed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "oldQuorumCoefficient",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "newQuorumCoefficient",
                type: "uint32",
            },
        ],
        name: "QuorumCoefficientSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldQuorumVotesBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "QuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "refundAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "refundSent",
                type: "bool",
            },
        ],
        name: "RefundableVote",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingDelay",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "VotingDelaySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "VotingPeriodSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "sent",
                type: "bool",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "BALLOT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_QUORUM_VOTES_BPS_UPPER_BOUND",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_REFUND_BASE_FEE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_REFUND_GAS_USED",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_REFUND_PRIORITY_FEE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_QUORUM_VOTES_BPS_LOWER_BOUND",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_QUORUM_VOTES_BPS_UPPER_BOUND",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REFUND_BASE_GAS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptVetoer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_burnVetoPower",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "newMinQuorumVotesBPS",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "newMaxQuorumVotesBPS",
                type: "uint16",
            },
            {
                internalType: "uint32",
                name: "newQuorumCoefficient",
                type: "uint32",
            },
        ],
        name: "_setDynamicQuorumParams",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "newMaxQuorumVotesBPS",
                type: "uint16",
            },
        ],
        name: "_setMaxQuorumVotesBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "newMinQuorumVotesBPS",
                type: "uint16",
            },
        ],
        name: "_setMinQuorumVotesBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPendingVetoer",
                type: "address",
            },
        ],
        name: "_setPendingVetoer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "_setProposalThresholdBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "newQuorumCoefficient",
                type: "uint32",
            },
        ],
        name: "_setQuorumCoefficient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "_setVotingDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "_setVotingPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_withdraw",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castRefundableVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castRefundableVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "castVoteBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "totalSupply",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOStorageV2.DynamicQuorumParams",
                name: "params",
                type: "tuple",
            },
        ],
        name: "dynamicQuorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "getActions",
        outputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "blockNumber_",
                type: "uint256",
            },
        ],
        name: "getDynamicQuorumParamsAt",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOStorageV2.DynamicQuorumParams",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
        ],
        name: "getReceipt",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct NounsDAOStorageV1Adjusted.Receipt",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "timelock_",
                type: "address",
            },
            {
                internalType: "address",
                name: "nouns_",
                type: "address",
            },
            {
                internalType: "address",
                name: "vetoer_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "votingPeriod_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "votingDelay_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "proposalThresholdBPS_",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOStorageV2.DynamicQuorumParams",
                name: "dynamicQuorumParams_",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxQuorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minQuorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nouns",
        outputs: [
            {
                internalType: "contract NounsTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingVetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalMaxOperations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThresholdBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "proposer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "proposalThreshold",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quorumVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "eta",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "startBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "forVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "againstVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "abstainVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "canceled",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "vetoed",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "executed",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "creationBlock",
                        type: "uint256",
                    },
                ],
                internalType: "struct NounsDAOStorageV2.ProposalCondensed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "queue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "quorumParamsCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "fromBlock",
                type: "uint32",
            },
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOStorageV2.DynamicQuorumParams",
                name: "params",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "quorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotesBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "state",
        outputs: [
            {
                internalType: "enum NounsDAOStorageV1Adjusted.ProposalState",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract INounsDAOExecutor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "veto",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsDAOLogicV2__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDAOLogicV2__factory = NounsDAOLogicV2__factory;
NounsDAOLogicV2__factory.bytecode = _bytecode;
NounsDAOLogicV2__factory.abi = _abi;
